"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDAOLogicV2__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "AdminOnly",
        type: "error",
    },
    {
        inputs: [],
        name: "CantCancelExecutedProposal",
        type: "error",
    },
    {
        inputs: [],
        name: "CantVetoExecutedProposal",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidMaxQuorumVotesBPS",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidMinQuorumVotesBPS",
        type: "error",
    },
    {
        inputs: [],
        name: "MinQuorumBPSGreaterThanMaxQuorumBPS",
        type: "error",
    },
    {
        inputs: [],
        name: "PendingVetoerOnly",
        type: "error",
    },
    {
        inputs: [],
        name: "UnsafeUint16Cast",
        type: "error",
    },
    {
        inputs: [],
        name: "VetoerBurned",
        type: "error",
    },
    {
        inputs: [],
        name: "VetoerOnly",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint16",
                name: "oldMaxQuorumVotesBPS",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "newMaxQuorumVotesBPS",
                type: "uint16",
            },
        ],
        name: "MaxQuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint16",
                name: "oldMinQuorumVotesBPS",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "newMinQuorumVotesBPS",
                type: "uint16",
            },
        ],
        name: "MinQuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingVetoer",
                type: "address",
            },
        ],
        name: "NewPendingVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "NewVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreatedWithRequirements",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ProposalQueued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProposalThresholdBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "ProposalThresholdBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalVetoed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "oldQuorumCoefficient",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "newQuorumCoefficient",
                type: "uint32",
            },
        ],
        name: "QuorumCoefficientSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldQuorumVotesBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "QuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "refundAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "refundSent",
                type: "bool",
            },
        ],
        name: "RefundableVote",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingDelay",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "VotingDelaySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "VotingPeriodSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "sent",
                type: "bool",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "BALLOT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_QUORUM_VOTES_BPS_UPPER_BOUND",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_REFUND_BASE_FEE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_REFUND_GAS_USED",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_REFUND_PRIORITY_FEE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_QUORUM_VOTES_BPS_LOWER_BOUND",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_QUORUM_VOTES_BPS_UPPER_BOUND",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REFUND_BASE_GAS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptVetoer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_burnVetoPower",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "newMinQuorumVotesBPS",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "newMaxQuorumVotesBPS",
                type: "uint16",
            },
            {
                internalType: "uint32",
                name: "newQuorumCoefficient",
                type: "uint32",
            },
        ],
        name: "_setDynamicQuorumParams",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "newMaxQuorumVotesBPS",
                type: "uint16",
            },
        ],
        name: "_setMaxQuorumVotesBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "newMinQuorumVotesBPS",
                type: "uint16",
            },
        ],
        name: "_setMinQuorumVotesBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPendingVetoer",
                type: "address",
            },
        ],
        name: "_setPendingVetoer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "_setProposalThresholdBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "newQuorumCoefficient",
                type: "uint32",
            },
        ],
        name: "_setQuorumCoefficient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "_setVotingDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "_setVotingPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_withdraw",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castRefundableVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castRefundableVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "castVoteBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "totalSupply",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOStorageV2.DynamicQuorumParams",
                name: "params",
                type: "tuple",
            },
        ],
        name: "dynamicQuorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "getActions",
        outputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "blockNumber_",
                type: "uint256",
            },
        ],
        name: "getDynamicQuorumParamsAt",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOStorageV2.DynamicQuorumParams",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
        ],
        name: "getReceipt",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct NounsDAOStorageV1Adjusted.Receipt",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "timelock_",
                type: "address",
            },
            {
                internalType: "address",
                name: "nouns_",
                type: "address",
            },
            {
                internalType: "address",
                name: "vetoer_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "votingPeriod_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "votingDelay_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "proposalThresholdBPS_",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOStorageV2.DynamicQuorumParams",
                name: "dynamicQuorumParams_",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxQuorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minQuorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nouns",
        outputs: [
            {
                internalType: "contract NounsTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingVetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalMaxOperations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThresholdBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "proposer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "proposalThreshold",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "quorumVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "eta",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "startBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endBlock",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "forVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "againstVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "abstainVotes",
                        type: "uint256",
                    },
                    {
                        internalType: "bool",
                        name: "canceled",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "vetoed",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "executed",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "totalSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "creationBlock",
                        type: "uint256",
                    },
                ],
                internalType: "struct NounsDAOStorageV2.ProposalCondensed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "queue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "quorumParamsCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "fromBlock",
                type: "uint32",
            },
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "maxQuorumVotesBPS",
                        type: "uint16",
                    },
                    {
                        internalType: "uint32",
                        name: "quorumCoefficient",
                        type: "uint32",
                    },
                ],
                internalType: "struct NounsDAOStorageV2.DynamicQuorumParams",
                name: "params",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "quorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotesBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "state",
        outputs: [
            {
                internalType: "enum NounsDAOStorageV1Adjusted.ProposalState",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract INounsDAOExecutor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "veto",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsDAOLogicV2__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDAOLogicV2__factory = NounsDAOLogicV2__factory;
NounsDAOLogicV2__factory.bytecode = _bytecode;
NounsDAOLogicV2__factory.abi = _abi;
